/**
 * Styled Components - Created by gustavomedina on 16/04/18.
 */
import styled from 'styled-components'
import Input from 'antd/lib/input'
import AntdButton from 'antd/lib/button'
import { GRAY_DARK, RED } from '../../theme/colors'

export const Container = styled.div`
  background-color: #222;
`

export const Text = styled.div`
  color: #fff;
`

export const Title = styled.div`
  color: #5f6062;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const TitleLabel = styled.div`
  height: 19px;
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
  margin-top: 15px;
  margin-bottom: 5px;
`

export const StyledInput = styled(Input)`
  margin-bottom: 20px;
  margin-top: 0px;
  border-radius: 0px;
  width: 100%;
`

export const StyledInputBox = styled(Input)`
  margin-bottom: 20px;
  margin-top: 0px;
  border-radius: 0px;
  width: 100%;
  height: 40%;
`

export const Button = styled(AntdButton)`
  height: 40px;
  width: 93px;
`

export const ButtonWrapper = styled.div`
  margin-bottom: 10px;
  margin-top: 15px;
  text-align: right;
  align-items: center;

  .ant-btn-primary {
    background-color: #4a90e2;
    border-color: #4a90e2;
    max-width: 120px;
    width: 100%;
    display: inline-flex;
    justify-content: space-evenly;
    align-items: center;
  }
  .ant-btn-primary:hover {
    background-color: #4a90e2;
    border-color: #4a90e2;
  }
`

export const ExtraFields = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
`

export const FieldContainer = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: start;
  flex-direction: column;
`

interface LabelProps {
  required: boolean
}

export const Label = styled.p`
  margin: 0 10px 10px 0;
  width: 200px;
  &::after{
    content: '${({ required }: LabelProps) => (required ? ' *' : '')}';
    color: ${RED}
  }
`

export const BottomText = styled.div`
  text-align: center;
  color: ${GRAY_DARK};
  font-size: 13px;
  letter-spacing: 0.18px;
  line-height: 19px;
  max-width: 328px;
  margin: 0 auto;
  margin-top: 18px;
`

export const IconBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: var(--radius-full);
  background: var(--neutral-lightest-block);
  flex-shrink: 0;
`

export const BadgeIcon = styled.img`
  display: block;
  width: 26px;
  height: 26px;
  object-fit: contain;
`

export const SendIcon = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
  flex-shrink: 0;
`

export const ContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
  width: 100%;
`

export const FormBody = styled.div`
  &[data-appearance='v2'] {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-16);

    #header-block {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-16);
      width: 100%;
      #modal-heading {
        margin: 0;
        font: 600 32px/38px var(--font-barlow-semi-condensed);
        color: var(--neutral-darkest);
        text-transform: capitalize;
      }
    }

    #info-note {
      display: flex;
      align-items: flex-start;
      gap: var(--spacing-8);
      width: 100%;
      ${BottomText} {
        margin: 0;
        text-align: left;
        max-width: none;
        font: 400 14px/22px var(--font-inter);
        color: var(--neutral-secondary);
      }
    }

    #info-icon {
      width: 18px;
      height: 24px;
      object-fit: contain;
      flex-shrink: 0;
    }

    ${Title} {
      display: none;
    }

    ${TitleLabel} {
      display: none;
    }

    ${ExtraFields} {
      margin-top: 0;
      gap: var(--spacing-16);
    }

    ${FieldContainer} {
      margin-bottom: 0;
      width: 100%;
      gap: var(--spacing-8);
    }

    ${Label} {
      margin: 0;
      width: auto;
      font: 600 12px/20px var(--font-barlow);
      letter-spacing: 1px;
      text-transform: uppercase;
      color: var(--neutral-darkest);
      display: flex;
      align-items: center;
      gap: var(--spacing-4);
      &::after {
        color: var(--neutral-secondary);
        font: 500 14px/20px var(--font-barlow);
        letter-spacing: 1px;
      }
    }

    .ant-input {
      height: 44px;
      margin: 0;
      padding: 0 16px;
      background: var(--neutral-fill-lightest);
      border: var(--border-regular) solid var(--neutral-border-med);
      border-radius: 0;
      box-shadow: none;
      font: 400 14px/22px var(--font-inter);
      color: var(--neutral-darkest);
      &::placeholder {
        color: var(--neutral-muted);
      }
      &:focus,
      &:hover {
        border-color: var(--neutral-border-med);
        box-shadow: none;
      }
    }

    textarea.ant-input {
      height: 72px;
      min-height: 72px;
      padding: 12px 16px;
      resize: none;
    }

    ${ButtonWrapper} {
      margin: 0;
      text-align: left;
      width: 100%;
      ${Button} {
        width: 100%;
        height: 42px;
        max-width: none;
      }
      .ant-btn-primary {
        height: 42px;
        width: 100%;
        max-width: none;
        background: var(--neutral-darkest);
        border: none;
        border-radius: 0;
        font: 600 12px/18px var(--font-barlow);
        letter-spacing: 1px;
        text-transform: uppercase;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        gap: var(--spacing-12);
        color: var(--neutral-white);
      }
      .ant-btn-primary:hover,
      .ant-btn-primary:focus {
        background: var(--neutral-body);
        border: none;
        color: var(--neutral-white);
      }
    }

    @media (min-width: 1440px) and (min-height: 1000px) {
      gap: var(--spacing-24);

      ${ExtraFields} {
        gap: var(--spacing-24);
      }

      textarea.ant-input {
        height: 96px;
        min-height: 96px;
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/EmailContact/styledComponents.tsx